import { Typography } from '@mui/material'
import get from 'lodash/get'
import { FieldProps, RaRecord } from 'react-admin'
import { sanitizeFieldRestProps } from './types'
import { FC } from 'react'

export const SvgField: FC<SvgFieldProps> = (props) => {
  const {
    emptyText,
    className,
    source,
    record,
  } = props
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const image = typeof record === 'string' ? record : get(record, source) as string

  if (image !== null && image !== undefined) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const value = typeof image === 'string' ? image : get(image, source) as string
    const sanitizedImage = value && value.indexOf('blob:') === 0 ? value : `data:image/svg+xml;base64,${value}`
    return <img className={className} alt='Icon' src={sanitizedImage} />
  }

  return (
    <Typography
      component="span"
      variant="body2"
      className={className}
      {...sanitizeFieldRestProps(props)}
    >
      {emptyText}
    </Typography>
  )
}

interface SvgFieldProps extends FieldProps {
  source: string;
  record?: RaRecord;
}
